module.exports = __webpack_public_path__ + "static/bank@2x-f6475f8ce398e73c4c72e3d9ce0f2f27.png";